import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from 'src/context/auth/AuthContext';
import Spinner from 'src/views/spinner/Spinner';

/**
 * Route guard. `not-authorised` goes to the login page too, which renders the explanation —
 * the session has already been deleted by the provider, so there is nothing to sign out of.
 */
const RequireInternal = ({ children }: { children: ReactNode }) => {
  const { status } = useAuth();

  if (status === 'loading') return <Spinner />;
  if (status !== 'ready') return <Navigate to="/login" replace />;
  return <>{children}</>;
};

export default RequireInternal;
